// Montessori
import React from 'react';
import FavouriteAnimal2025  from 'views/FavouriteAnimal2025';

const Montessoripage = () => {
  return <FavouriteAnimal2025/>;
};

export default Montessoripage;